




































































































































































import FlightPassengerList from "@/store/entities/flight/flightPassengerList";
import FlightReservationOrder from "@/store/entities/flight/reservation/flightReservationOrder";
import { PropType } from "vue";
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import ReservationDetailModal from "../views/pages/flight/modals/reservationDetailModal.vue";
@Component({
  components: { ReservationDetailModal },
})
export default class CustomTable extends Vue {
  @Prop({ type: Array as PropType<FlightPassengerList[]> })
  flightPassenger!: FlightPassengerList[];
  name: string = "CustomTable";
  headers: any[] = [];
  isCheckAll: boolean = false;
  checkedPassengers: FlightReservationOrder[] = [];
  isOpenModal:boolean=false;
  created() {
    this.headers = [
      { text: "PNR", value: "pnr" },
      { text: "Güzergah", value: "destination" },
      { text: "Uçuş Numarası", value: "flightNo" },
      { text: "Acente", value: "agency" },
      { text: "Operatör", value: "code" },
      { text: "Soyadı", value: "surname" },
      { text: "İsim", value: "name" },
      { text: "Cinsiyet", value: "gender" },
    ];
  }
  async openReservationDetail(item){
  
    await this.$store.dispatch({
      type: "reservation/getFlightOrders",
      data: item.orderId,
    });
    this.isOpenModal=true;
  }
  closeModal() {
  
  this.isOpenModal = false;
  
}
  checkAll(index) {
    if (this.flightPassenger[index].isChecked) {
      this.flightPassenger[index].isChecked=true;
        for (let item of this.flightPassenger[index].flightOrders) {
              var checkItem = this.checkedPassengers.find(x=>x.orderNo==item.orderNo);
              if(checkItem==null){
                this.checkedPassengers.push(item);
              }
            
        }
    }
    else{
      this.flightPassenger[index].isChecked=false;
      for (let item of this.flightPassenger[index].flightOrders) {
      var checkItem = this.checkedPassengers.find(x=>x.orderNo==item.orderNo);
      if(checkItem!=null){
        var indexOf = this.checkedPassengers.indexOf(checkItem);
        this.checkedPassengers.splice(indexOf,1);
      }
    
}
      
    }
    console.log( this.checkedPassengers)
  }
  @Emit("checked-passenger")
  sendPassenger() {
    return this.checkedPassengerList;
  }
  get checkedPassengerList() {
    return this.checkedPassengers;
  }
  @Watch("checkedPassengers")
  onChangePassengerCheckedList() {
    console.log(this.checkedPassengers);
    this.$store.commit({
      type: "flightPassengers/setCheckedPassengerList",
      data: this.checkedPassengers,
    });
  }
}
